import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import * as z from "zod";
import { generalErrorCodes } from "shared/errors/generalErrorCodes";
import { TFunction } from "i18next";

const ChangePasswordSchema = z.object({
  success: z.literal(true),
});
export interface MutateChangePasswordParams {
  oldPassword: string;
  newPassword: string;
}

export const mutateChangePassword = async (values: MutateChangePasswordParams) => {
  const response = await makeMutation(ApiEndpoints.changePassword(), values, true, 'POST', changePasswordErrorCodes);
  return ChangePasswordSchema.parse(response);
};

export const changePasswordErrorCodes = {
  ...generalErrorCodes,
  INVALID_OLD_PASSWORD: {
    code: "INVALID_OLD_PASSWORD",
    translation: (t: TFunction) => t("Invalid password"),
  },
};